import type { FC } from 'react';

export type ThrowErrorProps = {
  /**
   * The error to throw.
   */
  error: Error;
};

export const ThrowError: FC<ThrowErrorProps> = ({ error }) => {
  throw error;
};
